<script setup>
import { computed } from 'vue';
import ContactDetailsItem from '../ContactDetailsItem.vue';

const props = defineProps({
  contact: {
    type: Object,
    default: () => ({}),
  },
  conversationCampaign: {
    type: Object,
    default: () => ({}),
  },
  conversationAttributes: {
    type: Object,
    default: () => ({}),
  },
  conversationCustomAttributes: {
    type: Object,
    default: () => ({}),
  },
});

const normalizeCampaignValue = value => {
  if (!value) return '';
  if (['string', 'number'].includes(typeof value)) {
    return String(value).trim();
  }
  if (typeof value !== 'object') return '';

  return [
    'title',
    'name',
    'campaign_name',
    'campaignName',
    'campaign',
    'campanha',
    'utm_campaign',
    'utmCampaign',
    'headline',
    'value',
  ].reduce(
    (campaign, key) => campaign || normalizeCampaignValue(value[key]),
    ''
  );
};

const findCampaignValue = (attributes = {}) =>
  [
    'campaign_name',
    'campaignName',
    'campaign_title',
    'campaignTitle',
    'campaign',
    'campanha',
    'nome_campanha',
    'nomeCampanha',
    'utm_campaign',
    'utmCampaign',
    'lead_campaign',
    'leadCampaign',
    'source_campaign',
    'sourceCampaign',
    'origem_campanha',
    'origemCampanha',
    'referral',
  ].reduce(
    (campaign, key) => campaign || normalizeCampaignValue(attributes[key]),
    ''
  );

const additionalAttributes = computed(
  () => props.contact.additional_attributes || {}
);

const contactCustomAttributes = computed(
  () => props.contact.custom_attributes || props.contact.customAttributes || {}
);

const campaignValue = computed(() => {
  const campaign = normalizeCampaignValue(props.conversationCampaign);
  if (campaign) return campaign;

  return [
    props.conversationCustomAttributes,
    props.conversationAttributes,
    additionalAttributes.value,
    contactCustomAttributes.value,
  ].reduce((value, attributes) => value || findCampaignValue(attributes), '');
});
</script>

<template>
  <div>
    <ContactDetailsItem
      v-if="campaignValue"
      :title="$t('CONVERSATION_SIDEBAR.CAMPAIGN.NAME')"
      :value="campaignValue"
    />
    <p v-else class="px-6 py-6 text-sm leading-6 text-center text-n-slate-11">
      {{ $t('CONVERSATION_SIDEBAR.CAMPAIGN.EMPTY_STATE') }}
    </p>
  </div>
</template>
